import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh;
  margin: 0;
`
export const WrapperDetail = styled.div`
  width: 416px;
`
export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 24px;
`

export const IconCircle = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.player20};
`

export const NoReleaseTitle = styled.h1`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  padding-bottom: 8px;
  color: ${({ theme }) => theme.colors.neutralW90};
`

export const ReleaseDetails = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const ReleaseSupport = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const ReleaseSupportDetails = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW70};
  padding-right: 6px;
`

export const ReleaseLink = styled.button`
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.interact70};
`
